import React, { useState } from "react";
import {
  Card,
  Col,
  Container,
  Row,
  Button,
  Form,
  Collapse,
  Image,
} from "react-bootstrap";
import Bigimg from "../../assets/img/photo1.png";
import {
  RecomedListedSliderSettings,
  ListedShortSliderSetting,
} from "../../data/SliderSettings";
import MainSlider from "../../component/sliders/MainSlider";
import { RecomedSlides, ShortVideoSLides } from "../../data/Data";
import VideoCardDetailed from "../../component/VideoCardDetailed";
import ShotVideoCard from "../../component/ShortVideoCard";
import OwnerCard from "../UserPannel/properties/OwnerCard";
import AgentDashBoardLayout from "../../layout/DashBoardLayouts/AgentDashBoardLayout";
const AgentListedProperty = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <AgentDashBoardLayout>
        <Container>
          {/* New sction */}
          <Row>
            <Col md={8}>
              {/* New section */}
              <MainSlider
                SliderSetting={RecomedListedSliderSettings}
                ClassProperty="pb-5"
                SectionTitle="Properties"
                SectionSubTitle="
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Eveniet, ipsa illo."
              >
                {RecomedSlides.map((Item) => (
                  <div key={Item.id}>
                    <VideoCardDetailed
                      ClassProperty="m-1 recomend-card"
                      title={Item.title}
                      propertImage={Item.propertImage}
                      clientname={Item.clientname}
                      timeline={Item.timeline}
                    />
                  </div>
                ))}
              </MainSlider>
              <MainSlider
                SliderSetting={ListedShortSliderSetting}
                ClassProperty="py-5"
                SectionTitle="Short Video"
                SectionSubTitle="
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Eveniet, ipsa illo."
              >
                {ShortVideoSLides.map((Item) => (
                  <div key={Item.id}>
                    <ShotVideoCard
                      ClassProperty=""
                      Thumbnel={Item.url}
                      title={Item.title}
                    />
                  </div>
                ))}
              </MainSlider>
            </Col>
            <Col md={4}>
              <OwnerCard />
            </Col>
          </Row>
        </Container>
      </AgentDashBoardLayout>
    </>
  );
};

export default AgentListedProperty;
